import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRoboto, theme } from "shared/lib/styles";

import { BaseImage } from "scmp-app/components/common/base-image";

import PlayButton from "./play-button.svg";

type Props = {
  $isHeroVideo: boolean;
};

export const PreviewImage = styled(BaseImage)`
  position: relative;

  margin: 0;

  overflow: hidden;
`;

type PreviewContentContainerProps = {
  $orientation?: "landscape" | "portrait";
};

export const PreviewContentContainer = styled.div<PreviewContentContainerProps>`
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;

  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: ${props => (props.$orientation === "portrait" ? "flex-start" : "flex-end")};

  inline-size: 100%;
  block-size: 100%;
  padding-block: 20px;
  padding-inline: 16px;

  column-gap: 12px;

  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6));

  ${theme.breakpoints.up("tablet")} {
    block-size: 100%;
    padding-inline: 32px;
  }
`;

type PreviewContainerProps = {
  $orientation?: "landscape" | "portrait";
};
export const PreviewContainer = styled.div<PreviewContainerProps>`
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: center;

  block-size: 100%;

  cursor: pointer;

  ${props =>
    props.$orientation === "portrait" &&
    css`
      &&& {
        inline-size: var(--portrait-inline-size);
        margin-inline: auto;
        ${theme.breakpoints.only("mobile")} {
          block-size: auto;
        }
      }

      ${PreviewContentContainer} {
        inline-size: var(--portrait-inline-size);
        aspect-ratio: 9/16;
        ${theme.breakpoints.only("mobile")} {
          block-size: auto;
        }
      }

      ${PreviewImage} {
        inline-size: var(--portrait-inline-size);
        block-size: auto;
        aspect-ratio: 9/16;
        ${theme.breakpoints.only("mobile")} {
          block-size: auto;
        }
      }
    `}

  ${props => props.theme.breakpoints.up("tablet")} {
    block-size: auto;
  }
`;

export const StyledPlayButton = styled(PlayButton)``;

export const PreviewPlayButtonContainer = styled.div<Props>`
  margin-inline-end: 12px;

  ${StyledPlayButton} {
    ${props =>
      props.$isHeroVideo
        ? css`
            inline-size: 40px;
            block-size: 40px;
            ${theme.breakpoints.up("tablet")} {
              inline-size: 60px;
              block-size: 60px;
            }
          `
        : css`
            inline-size: 28px;
            block-size: 28px;
            ${theme.breakpoints.up("tablet")} {
              inline-size: 32px;
              block-size: 32px;
            }
          `}
  }

  ${theme.breakpoints.up("tablet")} {
    ${props =>
      props.$isHeroVideo
        ? css`
            display: flex;
            align-items: center;

            margin-block-start: 0;
            margin-inline-end: 20px;
          `
        : css`
            display: flex;
            align-items: flex-start;

            margin-block-start: 0;
            margin-inline-end: 12px;
          `}
  }
`;

export const PreviewContentFloatContainer = styled.div`
  display: flex;

  x ${theme.breakpoints.up("tablet")} {
    inline-size: 508px;
  }
`;

export const PreviewTitle = styled.p<Props>`
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 16px;

  ${theme.breakpoints.up("tablet")} {
    ${props =>
      props.$isHeroVideo
        ? css`
            font-size: 24px;
            line-height: 34px;
          `
        : css`
            font-size: 14px;
            line-height: 16px;
          `}
  }
`;

export const PreviewDuration = styled.p<Props>`
  inline-size: fit-content;
  padding: 2px;

  color: #4585ff;
  font-weight: 700;
  font-size: 10px;
  font-family: ${fontRoboto};
  line-height: 12px;

  background-color: #ffffff;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 2px;

    ${props =>
      props.$isHeroVideo &&
      css`
        font-size: 18px;
        line-height: 21px;
      `}
  }
`;

export const PreviewContentDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  justify-content: center;

  /* Override the style in content schema render */
  ${PreviewTitle}, ${PreviewDuration} {
    margin-block: 0;
  }
`;
